import styled from 'styled-components';

const StyledFunctionWrapper = ({ children, className }) => {
  return children(className);
};

const StyledDatePickerWrapper = styled(StyledFunctionWrapper)`
  ul {
    -webkit-padding-start: 0;
  }
`;

const StyledBlankWithOrder3 = styled.div`
  width: 8px;
  order: 3;
`;

export { StyledDatePickerWrapper, StyledBlankWithOrder3 };
